// extracted by mini-css-extract-plugin
module.exports = {"searchWrapper":"AqfaB"};